import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation CurriculumEnable($cuid: String!){
        curriculum_enable (cuid: $cuid) {
            uid
        }
    }
`;

export async function curriculumEnable(cuid: string): Promise<string> {
    const result: FetchResult<{ curriculum_enable: { uid: string }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { cuid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.curriculum_enable.uid;
}
